import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';
import { useTheme } from '../context/ThemeContext';

const BlogPage = () => {
  const { theme } = useTheme();

  return (
    <>
      <Helmet>
        <title>Blog & Insights | BookMyAudition</title>
      </Helmet>
      <div 
        className="blog-page" 
        style={{ 
          minHeight: '70vh', 
          padding: '60px 0',
          backgroundColor: theme === 'dark' ? '#0a0a14' : '#f8fafc',
          color: theme === 'dark' ? '#f8fafc' : '#111'
        }}
      >
        <Container>
          <Row className="justify-content-center text-center">
            <Col md={8}>
              <h1 className="fw-bold mb-4" style={{ color: theme === 'dark' ? '#fff' : '#111' }}>
                Our Blog
              </h1>
              <p style={{ color: theme === 'dark' ? '#cbd5e1' : '#475569', fontSize: '1.1rem' }}>
                Get the latest tips on auditioning, industry insights, and acting guides written by professionals to help you grow.
              </p>
              
              <div 
                className="coming-soon-box mt-5 p-5 rounded-4 shadow-sm"
                style={{
                  backgroundColor: theme === 'dark' ? '#111116' : '#fff',
                  border: `1px solid ${theme === 'dark' ? '#1f1f2e' : '#eaeaea'}`
                }}
              >
                <div 
                  className="d-inline-block mb-3 px-3 py-1 rounded-pill" 
                  style={{ 
                    backgroundColor: 'rgba(245, 158, 11, 0.1)', 
                    color: '#f59e0b',
                    fontSize: '0.85rem',
                    fontWeight: '600',
                    border: '1px solid rgba(245, 158, 11, 0.2)'
                  }}
                >
                  INSIGHTS & TIPS
                </div>
                <h3 className="fw-bold mb-3">Articles Coming Soon</h3>
                <p className="mb-0 text-muted">
                  Our industry experts are busy writing high-quality guides and news for you. We'll be launching our first set of articles very soon!
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default BlogPage;